export const GetTxnTypes = async () => {

    try {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL

        const requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}common/TxnUpdateTypes`, requestOptions);

        if (response.status === 200) {
            const result = await response.json();
            return result.data;
        }

        return [];
    } catch (error) {
        console.error('Error fetching transaction types:', error);
        // You can also return a default value or rethrow the error if needed
        return []; // or throw error;
    }
}


export const SaveTransaction = async (formData) => {
    try {
        const authToken = localStorage.getItem("authToken")
        const ApiURL = window.Links.ApiURL

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(formData),
            redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}txn/updateTransaction`, requestOptions);

        if (response.status === 200) {
            const result = await response.json();
            return { success: result.success, message: result.message };
        }

        return { success: false, message: 'Error saving transaction' };
    } catch (error) {
        console.error('Error saving transaction:', error);
        return { success: false, message: 'Error saving transaction' };
    }
}